export const SUPPORT_CENTER_BASE_PATH = '/support-center';

export const SUPPORT_CENTER_ROUTE_PATTERN = `${SUPPORT_CENTER_BASE_PATH}/*`;
